import EditSolarForm from "./EditSolarForm";

export default EditSolarForm;
